import { Mapper } from '../../../../domain/adapters/mapper.adapter';
import { CategoryItemModel } from '../../../../domain/models/category.model';
import { CategoryItemEntity } from '../categories.responses';

export class CategoryItemEntityMapper extends Mapper<
  CategoryItemEntity,
  CategoryItemModel
> {
  mapFrom(entity: CategoryItemEntity): CategoryItemModel {
    return {
      id: entity.id,
      name: entity.name,
      slug: entity.slug,
    };
  }

  mapTo(model: CategoryItemModel): CategoryItemEntity {
    throw new Error('Method not implemented.');
  }
}
